// Components
import { forwardRef } from "react";
import { Button } from "@mui/material";

// Constants
import { darkBlue, hoverBlue, disabledGrey } from "./ColourConstants";

const CustomButton = forwardRef(function CustomButton(
  {
    label,
    startIcon,
    onClick,
    sx,
    disabled = false,
    type = "primary", // "primary", "secondary", "colour"
    color,
    ...props
  },
  ref
) {
  const baseStyles = {
    borderRadius: "28px",
    width: "fit-content",
    height: "fit-content",
    ...sx,
  };
  const styles = {
    primary: {
      ...baseStyles,
      backgroundColor: darkBlue,
      "&:hover": {
        backgroundColor: hoverBlue,
      },
      "&.Mui-disabled": {
        backgroundColor: disabledGrey,
      },
    },
    secondary: {
      ...baseStyles,
      borderColor: darkBlue,
      color: darkBlue,
    },
    colour: {
      ...baseStyles,
    },
  };

  return (
    <Button
      ref={ref}
      sx={styles[type]}
      onClick={onClick}
      startIcon={startIcon}
      disabled={disabled}
      color={color ?? undefined}
      variant={type === "secondary" ? "outlined" : "contained"}
      disableRipple={!!color}
      {...props}
    >
      {label}
    </Button>
  );
});

export default CustomButton;
